import { createDecorator, EquipeSelectModel, UnidadeSaudeSelectModel } from 'components/form'
import { MetaRoot } from 'util/metaPath'

import { InativacaoImoveisBuscaFormModel } from './model-inativacaoImoveis'

export const createInativacaoImoveisBuscaFormCalculator = (meta: MetaRoot<InativacaoImoveisBuscaFormModel>) =>
  createDecorator(
    {
      field: meta.unidadeSaude.absolutePath(),
      updates: {
        [meta.equipe.absolutePath()]: (
          unidadeSaude: UnidadeSaudeSelectModel,
          allValues: InativacaoImoveisBuscaFormModel,
          prevValues: InativacaoImoveisBuscaFormModel
        ) =>
          !unidadeSaude || (!!prevValues.unidadeSaude && prevValues.unidadeSaude !== unidadeSaude)
            ? null
            : allValues.equipe,
      },
    },
    {
      field: meta.equipe.absolutePath(),
      updates: {
        [meta.microarea.absolutePath()]: (
          equipe: EquipeSelectModel,
          allValues: InativacaoImoveisBuscaFormModel,
          prevValues: InativacaoImoveisBuscaFormModel
        ) => (!equipe || (!!prevValues.equipe && prevValues.equipe !== equipe) ? null : allValues.microarea),
      },
    }
  )
